import React, { useState } from "react";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import Column from "@amzn/meridian/column";
import LabsView from "./LabsView";
import Box from "@amzn/meridian/box";
import { FormattedMessage } from "react-intl";
import About from "./About";

const LabsSkeleton = () => {
  const [currentTab, setCurrentTab] = useState("about");
  return (
    <Column spacing="small" spacingInset="medium large none large">
      <TabGroup value={currentTab} onChange={setCurrentTab} fill="line">
        <Tab value="about">
          <FormattedMessage id="labs.faq" defaultMessage="About" />
        </Tab>
        <Tab value="tools">
          <FormattedMessage id="labs.tools" defaultMessage="Tools" />
        </Tab>
      </TabGroup>
      <Box>{currentTab === "tools" ? <LabsView /> : <About />}</Box>
    </Column>
  );
};

export default LabsSkeleton;



// WEBPACK FOOTER //
// ./src/components/labs/LabsSkeleton.js